<template>
  <div class="holder-app">
    <NavigateStepsMob />
    <div class="holder-app__bg-line">
      <RoundText />
      <NavigateSteps />
      <RoundSelectedList />
    </div>
    <div class="holder-app__container">
      <CircleBase>
        <template v-if="!loading">
          <VarningСhosen />
          <transition v-for="(step, index) in stepComponents" :key="index">
            <component
              v-if="step === activeStepComponent"
              v-bind:is="step"
            ></component>
          </transition>
        </template>
        <Loading v-else />
      </CircleBase>
      <NavigateArrows class="holder-app__navigation" />
    </div>
  </div>
</template>

<script>
import BasicComponent from '@/class/BasicComponent';

export default new BasicComponent({
  computed: {
    activeStepComponent() {
      const step = this.$store.getters.getActiveStep;
      return BasicComponent.componentFromStepName(step);
    },
    stepComponents() {
      return this.steps.map((step) => {
        return BasicComponent.componentFromStepName(step);
      });
    },
    steps() {
      return this.$store.getters.getSteps;
    },
    isComplete() {
      return this.$store.getters.isComplete;
    },
    loading() {
      return this.$store.getters.getLoading;
    },
  },
}).comp;
</script>

<style lang="scss">
.holder-app {
  position: relative;
  z-index: 0;

  &,
  &::before,
  &::after,
  *,
  *::before,
  *::after {
    box-sizing: unset;
  }
}

$topBottomGap: 60px;
.holder-app__bg-line {
  position: absolute;
  background-color: $green;
  width: 100%;
  left: 0;
  right: 0;
  top: $topBottomGap;
  bottom: $topBottomGap;
  z-index: 1;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 873 848'%3E%3Ccircle opacity='0.4' cx='436.5' cy='411.5' r='399.5' fill='none' stroke='white' stroke-width='6'/%3E%3Ccircle opacity='0.2' cx='436.5' cy='411.5' r='417.5' fill='none' stroke='white' stroke-width='4'/%3E%3Ccircle opacity='0.09' cx='436.5' cy='411.5' r='435.5' fill='none' stroke='white' stroke-width='2'/%3E%3C/svg%3E%0A");
  background-position: center 45%;
  background-repeat: no-repeat;
  background-size: auto calc(100% + #{$topBottomGap * 3});

  overflow: hidden;

  &::after {
    pointer-events: none;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: linear-gradient(
      to top,
      $green 0%,
      rgba($green, 0) 20%,
      rgba($green, 0) 80%,
      $green 100%
    );
  }
}

.holder-app__navigation {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 40%);
  pointer-events: auto;
}

.holder-app__container {
  pointer-events: none;
  box-sizing: unset;
  z-index: 4;
  position: relative;
}
</style>
